import {ReactElement} from "react";
import {StyledBoxColumn} from "../../../shared/StyledComponents";
import upperArch from "./res/images/upper_arch.svg";
import lowerArch from "./res/images/lower_arch.svg";
import fullArch from "./res/images/full_arch.svg";
import {SZ_LG, SZ_XXLG} from "../../../shared/dimens";
import {ButtonBase} from "@mui/material";

export enum Arch {
  UPPER = "upper",
  LOWER = "lower",
  FULL = "full",
}

export function ArchSelect(props: { style: any, arch: Arch, setArch: (arch: Arch) => void }): ReactElement {
  return <StyledBoxColumn style={{...props.style, alignItems: "center"}}>
    <ButtonBase onClick={() => props.setArch(Arch.UPPER)}>
      <img src={upperArch} style={{width: SZ_XXLG, aspectRatio: 1, opacity: props.arch === Arch.UPPER ? 1 : 0.5}}/>
    </ButtonBase>
    <ButtonBase onClick={() => props.setArch(Arch.FULL)}>
      <img src={fullArch} style={{
        width: SZ_LG,
        aspectRatio: 1,
        marginTop: -24,
        marginBottom: -48,
        opacity: props.arch === Arch.FULL ? 1 : 0.5
      }}/>
    </ButtonBase>
    <ButtonBase onClick={() => props.setArch(Arch.LOWER)}>
      <img src={lowerArch} style={{width: SZ_XXLG, aspectRatio: 1, opacity: props.arch === Arch.LOWER ? 1 : 0.5}}/>
    </ButtonBase>
  </StyledBoxColumn>
}